import type { NotificationCountsData, NotificationPageData } from "./domain";

export type NotificationListFilter={status:"unread"|"all";category?:string;createdFrom?:string;createdTo?:string;offset:number;limit:number};
export interface NotificationTransport {
  list(filter:NotificationListFilter,signal?:AbortSignal):Promise<NotificationPageData>;
  counts(signal?:AbortSignal):Promise<NotificationCountsData>;
  markRead(id:string,version:number):Promise<void>;
  markAllRead():Promise<void>;
  subscribe?(refresh:()=>void):()=>void;
}

function cookie(name:string){const prefix=`${encodeURIComponent(name)}=`;const value=document.cookie.split("; ").find((entry)=>entry.startsWith(prefix));return value?decodeURIComponent(value.slice(prefix.length)):"";}
async function mutation(path:string,version?:number){const response=await fetch(path,{method:"POST",credentials:"include",headers:{"X-CSRF-Token":cookie("pharmhub_csrf"),"Idempotency-Key":crypto.randomUUID(),...(version===undefined?{}:{"If-Match":String(version)})}});if(!response.ok)throw new Error("notifications unavailable");}

export function createHttpNotificationTransport():NotificationTransport {
  return {
    async list(filter,signal){const params=new URLSearchParams({status:filter.status,offset:String(filter.offset),limit:String(filter.limit)});if(filter.category)params.set("category",filter.category);if(filter.createdFrom)params.set("createdFrom",filter.createdFrom);if(filter.createdTo)params.set("createdTo",filter.createdTo);const response=await fetch(`/api/v1/notifications?${params}`,{signal,credentials:"include"});if(!response.ok)throw new Error("notifications unavailable");return response.json() as Promise<NotificationPageData>;},
    async counts(signal){const response=await fetch("/api/v1/notifications/counts",{signal,credentials:"include"});if(!response.ok)throw new Error("notification counts unavailable");return response.json() as Promise<NotificationCountsData>;},
    markRead:(id,version)=>mutation(`/api/v1/notifications/${encodeURIComponent(id)}/read`,version),
    markAllRead:()=>mutation("/api/v1/notifications/read-all"),
    subscribe:(refresh)=>{
      if(typeof EventSource==="undefined")return()=>{};
      let events:EventSource|null=null;
      let timer:ReturnType<typeof setTimeout>|undefined;
      let stopped=false;
      let delay=3000;
      const disconnect=()=>{
        if(timer!==undefined){clearTimeout(timer);timer=undefined;}
        if(events){events.removeEventListener("changed",changed);events.removeEventListener("session-expired",expired);events.removeEventListener("unavailable",unavailable);events.close();events=null;}
      };
      const changed=()=>{delay=3000;refresh();};
      const expired=()=>{stopped=true;disconnect();window.removeEventListener("online",online);window.dispatchEvent(new CustomEvent("pharmhub:session-expired"));};
      const connect=()=>{
        if(stopped||events||navigator.onLine===false)return;
        events=new EventSource("/api/v1/notifications/events",{withCredentials:true});
        events.addEventListener("changed",changed);
        events.addEventListener("session-expired",expired);
        events.addEventListener("unavailable",unavailable);
      };
      const unavailable=()=>{
        disconnect();
        if(stopped||navigator.onLine===false)return;
        timer=setTimeout(()=>{timer=undefined;connect();},delay);
        delay=Math.min(delay*2,30000);
      };
      const online=()=>{if(!stopped){disconnect();connect();}};
      window.addEventListener("online",online);
      connect();
      return()=>{stopped=true;disconnect();window.removeEventListener("online",online);};
    },
  };
}
